import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const { pathname } = window.location;

const currentUser = typeof localStorage !== 'undefined' && localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : {};

let locale = '';
if (pathname.includes('/pe')) {
  locale = 'pe';
} else if (pathname.includes('/br')) {
  locale = 'br';
} else if (pathname.includes('/cl')) {
  locale = 'cl';
} else if (!locale && currentUser && currentUser.user && currentUser.user.country) {
  locale = currentUser.user.country;
} else {
  locale = 'cl';
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'cl',
  messages: loadLocaleMessages(),
  silentTranslationWarn: process.env.NODE_ENV === 'prod'
});
export default i18n;
